import React from "react";
import { Star } from "lucide-react";
import { motion } from "framer-motion";
import { useI18n } from "../context/I18nContext";

export default function Testimonials() {
  const { t, tNode } = useI18n();
  const items = tNode("testimonials_data") || [];
  return (
    <section className="py-20 bg-[#082c50] text-white" data-testid="testimonials">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div>
            <span className="text-xs tracking-[0.2em] uppercase text-[#1a5193] font-chivo font-bold">
              {t("testimonials.eyebrow")}
            </span>
            <h2 className="font-chivo font-black text-3xl sm:text-4xl lg:text-5xl tracking-tight mt-3">
              {t("testimonials.title_a")} <br className="hidden sm:block" /> {t("testimonials.title_b")}
            </h2>
          </div>
          <div className="flex items-center gap-2">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-5 h-5 fill-[#1a5193] text-[#1a5193]" />
              ))}
            </div>
            <span className="text-sm text-gray-300">{t("testimonials.summary")}</span>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {items.map((item, idx) => (
            <motion.div
              key={idx}
              data-testid={`testimonial-${idx}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.1 }}
              className="bg-[#112240] p-8 border border-white/10"
            >
              <div className="flex mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="w-4 h-4 fill-[#1a5193] text-[#1a5193]" />
                ))}
              </div>
              <p className="text-gray-200 leading-relaxed mb-6">&ldquo;{item.text}&rdquo;</p>
              <div className="border-t border-white/10 pt-4">
                <div className="font-chivo font-bold">{item.name}</div>
                <div className="text-xs text-gray-400">{item.role}</div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
